import request from '@/utils/request'

export function index(params) {
    return request({
        url: 'visitors/guest_cars',
        method: 'get',
        params: params
    })
}

export function inventory(params) {
    return request({
        url: 'visitors/guest_car/inventory',
        method: 'get',
        params: params
    })
}
export function getCarVisitors(id) {
    return request({
        url: `/visitors/guest_car_visitors/${id}`,
        method: 'get'
    })
}

export function show(id) {
    return request({
        url: `/visitors/guest_cars/${id}`,
        method: 'get'
    })
}

export function store(data) {
    return request({
        url: `visitors/guest_cars`,
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: `visitors/guest_cars/${data.id}`,
        method: 'put',
        data
    })
}

export function destroy(id) {
    return request({
        url: `visitors/guest_cars/${id}`,
        method: 'delete',
    })
}
